/*! JointJS+ v4.2.2 (2026-01-22) - HTML5 Diagramming Framework

Copyright (c) 2025 client IO

This Source Code Form is subject to the terms of the JointJS+
License, v. 2.0. If a copy of the JointJS+ License was not
distributed with this file, You can obtain one at
https://www.jointjs.com/license or from the JointJS+ archive as was
distributed by client IO. See the LICENSE file.
*/
import * as joint from '@joint/plus';
import { inspectorDefinitions } from '../config/inspector';
var HIDDEN_CLASS_NAME = 'hidden';
var InspectorService = /** @class */ (function () {
    function InspectorService(_a) {
        var openGroupsButton = _a.openGroupsButton, closeGroupsButton = _a.closeGroupsButton, container = _a.container, header = _a.header, content = _a.content;
        var _this = this;
        openGroupsButton.addEventListener('click', function () { var _a; return (_a = _this.inspector) === null || _a === void 0 ? void 0 : _a.openGroups(); });
        closeGroupsButton.addEventListener('click', function () { var _a; return (_a = _this.inspector) === null || _a === void 0 ? void 0 : _a.closeGroups(); });
        this.header = header;
        this.content = content;
        this.container = container;
    }
    InspectorService.prototype.create = function (cell) {
        var _this = this;
        this.header.classList.remove(HIDDEN_CLASS_NAME);
        var _a = this.getInspectorConfig()[cell.get('type')], groups = _a.groups, inputs = _a.inputs;
        var inspector = joint.ui.Inspector.create(this.content, {
            cell: cell,
            groups: groups,
            inputs: inputs,
            container: this.container,
            renderFieldContent: function (options, path, _value, inspector) {
                if (options.type === 'image-picker') {
                    var label = document.createElement('label');
                    label.textContent = options.label;
                    var input = document.createElement('input');
                    input.type = 'file';
                    input.accept = 'image/x-png,image/gif,image/jpeg';
                    var field_1 = document.createElement('div');
                    field_1.appendChild(label);
                    field_1.appendChild(input);
                    input.addEventListener('change', function () {
                        inspector.updateCell(field_1, path, options);
                    });
                    return field_1;
                }
                // Use the default field renderer.
                return null;
            },
            getFieldValue: function (field, type) {
                if (type === 'image-picker') {
                    var file = field.querySelector('input').files.item(0);
                    return { value: file ? URL.createObjectURL(file) : '' };
                }
                // Use the default field value getter.
                return null;
            }
        });
        if (this.inspector !== inspector) {
            inspector.on('close', function () {
                _this.header.classList.add(HIDDEN_CLASS_NAME);
            });
            this.inspector = inspector;
        }
        return this.inspector;
    };
    InspectorService.prototype.getInspectorConfig = function () {
        return inspectorDefinitions;
    };
    return InspectorService;
}());
export { InspectorService };
